import { Grid, Stack, Typography, Button, CardMedia } from '@mui/material';
import { useState } from 'react';
import axios from 'axios';
import warrantyGuidelines from '../../../assets/homeowner-portal/warranty_guidelines.webp';
import { BASE_FILE_URL } from '../util';
import { downloadFile } from '../../../helpers';

export const ResidentialPerformanceGuide = () => {
  const [isDownloading, setIsDownloading] = useState({
    flyer: false,
    book: false,
    guide: false
  });
  return (
    <Grid
      container
      spacing={3}
      sx={{
        paddingLeft: theme => theme.spacing(3),
        paddingRight: theme => theme.spacing(3)
      }}
    >
      <Grid item xs={12} md={6}>
        <Stack
          gap={1}
          sx={{
            marginTop: {
              xs: 2,
              lg: 10
            }
          }}
        >
          <Typography variant="h2">Residential Performance Guidelines, 5th Edition</Typography>
          <Typography variant="body1">
            The Residential Performance Guidelines serve as a clear reference for how your home
            should perform and what to expect over time. These standards help outline what is
            considered normal wear and tear versus items covered under warranty, giving you peace of
            mind and transparency throughout your homeownership journey. They're designed to set
            expectations and ensure consistent quality across every Stone Martin home.
          </Typography>
          <Button
            variant="contained"
            sx={{
              width: { xs: '100%', md: '275px' },
              mt: 1,
              mb: 1
            }}
            disabled={isDownloading.guide ?? false}
            onClick={async () => {
              try {
                setIsDownloading({
                  ...isDownloading,
                  guide: true
                });
                const res = await axios.get(`${BASE_FILE_URL}/rcpg-5th-edition.pdf`, {
                  responseType: 'blob'
                });
                downloadFile(res.data, 'rcpg-5th-edition.pdf');
              } catch (error) {
                console.error('Error downloading guidelines:', error);
              } finally {
                setIsDownloading({
                  ...isDownloading,
                  guide: false
                });
              }
            }}
          >
            Click Here
          </Button>
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CardMedia
          component="img"
          image={warrantyGuidelines}
          alt="Talking around a table"
          sx={{
            height: {
              xs: '100%',
              md: '80%'
            },
            width: {
              xs: '100%',
              md: '80%'
            },
            objectFit: 'cover'
          }}
        />
      </Grid>
    </Grid>
  );
};
